import { log, LOG_LEVEL, LogLevel } from 'app/business-logic/services/log-service/log';

export function logError({
  componentStack,
  error,
  logLevel,
}: {
  componentStack?: string;
  error: string;
  logLevel?: LogLevel[keyof LogLevel];
}) {
  log({
    level: logLevel ?? LOG_LEVEL.Fatal,
    url: window.location.href,
    message: `[evs-omnis-frontend] ${error}`,
    exception: componentStack ?? '',
  });
}
